import { render, staticRenderFns } from "./ResComplexEditFrame.vue?vue&type=template&id=68ee9b7c&"
import script from "./ResComplexEditFrame.vue?vue&type=script&lang=js&"
export * from "./ResComplexEditFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports